// todo: find a nicer solution, maybe some model functionality to keep data models metadata
const PROJECT_TABLE_PRIMARY_KEY_PROPERTY_NAME = 'slug';
const PROFILE_TABLE_PRIMARY_KEY_PROPERTY_NAME = 'id';

export {
  PROFILE_TABLE_PRIMARY_KEY_PROPERTY_NAME, PROJECT_TABLE_PRIMARY_KEY_PROPERTY_NAME,
};
